import React from 'react'
import MatchCVResultPage from '../parts/pages/MatchCVResultPage'

export default function MatchCVResult() {
  return <MatchCVResultPage />
}
